import { jsx as r } from "react/jsx-runtime";
import n from "react";
const c = n.createContext(
  {}
), u = (t) => {
  const { children: e, ...o } = t;
  return /* @__PURE__ */ r(c.Provider, { value: o, children: e });
};
export {
  c as MultiSelectDropdownMenuContext,
  u as MultiSelectDropdownMenuContextProvider
};
//# sourceMappingURL=index.es2487.js.map
